import type { ApiFetchPerfilOficialBannersPort } from '~/handlers/ports/api-fetch-perfil-oficial-banners.port';
import type { BannerItem } from '~/utils/perfilOficialConfigs';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchPerfilOficialBannersAdapter
  implements ApiFetchPerfilOficialBannersPort
{
  async handle(slug: string): Promise<BannerItem[]> {
    const response = await fetch(`${getApostatudoApiUrl()}/banners/${slug}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return [];

    const data = await response.json();

    if (!Array.isArray(data)) return [];

    return data.map(
      (item: any): BannerItem => ({
        image: item.url,
        alt: item.filename || `Banner ${slug}`,
        linkUrl: item.link_url ?? null,
      }),
    );
  }
}
